export function Background(props: { style: React.CSSProperties }) {
  return (
    <div className="absolute top-0 right-0 left-0 -z-10 overflow-hidden">
      {/* Background gradients */}
      <div className="absolute inset-0" style={props.style} />

      {/* Animated bubbles */}
      <ul className="absolute right-0 bottom-0 left-0 m-0 list-none p-0">
        <li
          className="absolute bottom-0 left-[25%] h-20 w-20 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 25s linear infinite',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[10%] h-7.5 w-7.5 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 12s linear infinite',
            animationDelay: '2s',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[70%] h-5 w-5 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 25s linear infinite',
            animationDelay: '4s',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[40%] h-15 w-15 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 18s linear infinite',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[65%] h-5 w-5 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 25s linear infinite',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[75%] h-27.5 w-27.5 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 25s linear infinite',
            animationDelay: '3s',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[35%] h-37.5 w-37.5 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 25s linear infinite',
            animationDelay: '7s',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[50%] h-6.25 w-6.25 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 45s linear infinite',
            animationDelay: '15s',
            animationFillMode: 'backwards',
          }}
        />
        <li
          className="absolute bottom-0 left-[20%] h-6.25 w-6.25 rounded-[25%] bg-white"
          style={{
            animation: 'bubble 35s linear infinite',
            animationDelay: '2s',
            animationFillMode: 'backwards',
          }}
        />
      </ul>

      {/* Spacer for grid */}
      <div className="h-150" />

      {/* Curved bottom */}
      <svg
        className="fill-background relative z-10"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 100"
        preserveAspectRatio="none"
      >
        <path d="M 0 0 c 0 0 200 50 500 50 s 500 -50 500 -50 v 101 h -1000 v -100 z" />
      </svg>
    </div>
  )
}
